import { gql } from "graphql-tag";

export const REMOVE_APPLICANTS = gql`
  mutation RemoveApplicants(
    $interestListIds: [ID!]!
    $interestIds: [ID!]
    $status: String!
    $reason: String
  ) {
    changeInterestsStatus(
      interestListIds: $interestListIds
      interestIds: $interestIds
      status: $status
      reason: $reason
    )
  }
`;

export const NOT_DUPLICATE = gql`
  mutation NotDuplicate(
    $interestIds: [String!]!
    $criteria: [String!]!
    $otherCandidateIds: [String!]!
  ) {
    notDuplicate(
      interestIds: $interestIds
      criteria: $criteria
      otherCandidateIds: $otherCandidateIds
    ) {
      id
    }
  }
`;

export const PROPERTY_DUPLICATES = gql`
  query PropertyDuplicates($id: ID!) {
    interestList(id: $id) {
      id
      name
      property {
        id
        features {
          id
          name
        }
        duplicates {
          matchedFields
          showSocialColumn
          candidates {
            id
            firstName
            lastName
            email
            phone
            loginEmail
            loginPhone
            userId
            ssn
            propertyName
            submittedAt
            mailingAddress1
            mailingAddress2
            mailingCity
            mailingState
            mailingZip
            residenceAddress1
            residenceAddress2
            residenceCity
            residenceState
            residenceZip
          }
        }
      }
    }
  }
`;

export const PROPERTY_DUPLICATES_COUNT = gql`
  query PropertyDuplicatesCount($id: ID!) {
    interestList(id: $id) {
      id
      property {
        id
        duplicatesCount
      }
    }
  }
`;
